import { GeckoAnglePlotSetting } from 'types'
import {
  optionalNumberSchema,
  requiredIntSchema,
  requiredNumberSchema,
} from 'utils/zodHelpers'
import { z } from 'zod'

export const EditInspectionSchema = z.object({
  date: z.date({ message: 'Date is required' }),
  component: z.string({
    message: 'Component selection is required',
  }),
  salesforceJobId: z.string().optional(),
  display_component_type_id: requiredIntSchema,
  inspection_type: z.string({ message: 'Inspection Type is required' }),
  vertical_runs: z.boolean({
    message: 'Vertical runs must have a value',
  }),
  ndt_method_type: z.string({ message: 'Must be a valid NDT method' }),
  units: z.string({ message: 'Must be a valid unit selection' }),
  num_points: requiredNumberSchema,
  x_bin_size: requiredNumberSchema,
  y_bin_size: requiredNumberSchema,
  robot_types: z.array(z.string()).optional(),
  plot_rotation: optionalNumberSchema,
  sensor_offset: requiredNumberSchema,
  angle_variable: z.string({ message: 'Angle variable is required' }),
  angle_plot_settings: z.array(
    z.string({ message: 'Angle Plot Setting selection is required' })
  ),
  sensor_spacing: requiredNumberSchema,
  validation_thickness: z.string({
    message: 'Must be a valid thickness selection',
  }),
  low_threshold_relative_to_nominal: optionalNumberSchema,
  high_threshold_relative_to_nominal: optionalNumberSchema,
})

// function for converted the angle plot selected ids to angle plot settings objects using the lookup
export const getConvertedAnglePlotSettings = (apsIDS: string[]) => {
  const result: GeckoAnglePlotSetting[] = []
  apsIDS.map((id) => {
    const idAsNumber = parseInt(id)
    result.push(GeckoAnglePlotSetting.GetOrCreate(idAsNumber))
  })
  return result
}

export type EditInspectionSchema = z.infer<typeof EditInspectionSchema>

export const defaultValues: EditInspectionSchema = {
  date: new Date(),
  component: '',
  salesforceJobId: '',
  display_component_type_id: 1,
  inspection_type: '',
  vertical_runs: true,
  ndt_method_type: '',
  units: '',
  num_points: 1,
  x_bin_size: 0.25,
  y_bin_size: 0.25,
  robot_types: [],
  sensor_offset: 1,
  angle_variable: '',
  angle_plot_settings: [],
  sensor_spacing: 1,
  validation_thickness: '',
  low_threshold_relative_to_nominal: -0.04,
  high_threshold_relative_to_nominal: -0.01,
}
